<template>
    <div class="profile-page">
        <section class="section-about-cover section-shaped my-0">
            <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </section>
        <section class="section section-skew">
            <div class="container">
                <card shadow class="card-profile mt--300" no-body>
                    <div class="mb-3">
                        <div class="row text-center justify-content-center mt-5">
                            <div class="col-lg-8">
                                <h2 class="display-3 font-weight-light mb-3">Frequently Asked Questions</h2>
                            </div>
                        </div>
                        <div class="row mt-3 justify-content-center">
                            <div class="col-6 col-lg-2 col-md-4 col-sm-5 faq-div">
                                <base-button v-show="selectedCategory != 'general'" outline v-on:click="showQuestions('general')" class="faq-button" icon="ni ni-key-25" type="default">
                                    General
                                </base-button>
                                <base-button v-show="selectedCategory == 'general'" v-on:click="showQuestions('general')" class="faq-button" icon="ni ni-key-25" type="default">
                                    General
                                </base-button>
                            </div>
                            <div class="col-6 col-lg-2 col-md-4 col-sm-5 faq-div">
                                <base-button v-show="selectedCategory != 'safety'"
                                             v-on:click="showQuestions('safety')"
                                             outline class="faq-button" icon="ni ni-ambulance" type="danger">
                                    Safety
                                </base-button>
                                <base-button v-show="selectedCategory == 'safety'"
                                             v-on:click="showQuestions('safety')"
                                             class="faq-button" icon="ni ni-ambulance" type="danger">
                                    Safety
                                </base-button>

                            </div>
                            <div class="col-6 col-lg-2 col-md-4 col-sm-5 faq-div">
                                <base-button  v-show="selectedCategory != 'bookings'"
                                              v-on:click="showQuestions('bookings')"
                                             outline class="faq-button" type="primary" icon="ni ni-basket">
                                    Bookings
                                </base-button>
                                <base-button  v-show="selectedCategory == 'bookings'"
                                              v-on:click="showQuestions('bookings')"
                                              class="faq-button" type="primary" icon="ni ni-basket">
                                    Bookings
                                </base-button>
                            </div>
                            <div class="col-6 col-lg-2 col-md-4 col-sm-5 faq-div">
                                <base-button  v-show="selectedCategory != 'tips'"
                                              v-on:click="showQuestions('tips')"
                                             outline class="faq-button" icon="ni ni-bulb-61" type="warning">
                                    Tips
                                </base-button>
                                <base-button  v-show="selectedCategory == 'tips'"
                                              v-on:click="showQuestions('tips')"
                                             class="faq-button" icon="ni ni-bulb-61" type="warning">
                                    Tips
                                </base-button>
                            </div>
                            <div class="col-6 col-lg-2 col-md-4 col-sm-5 faq-div">
                                <base-button  v-show="selectedCategory != 'corporate'"
                                              v-on:click="showQuestions('corporate')"
                                             outline class="faq-button" icon="ni ni-building" type="success">
                                    Corporate
                                </base-button>
                                <base-button  v-show="selectedCategory == 'corporate'"
                                              v-on:click="showQuestions('corporate')"
                                             class="faq-button" icon="ni ni-building" type="success">
                                    Corporate
                                </base-button>
                            </div>
                        </div>
                    </div>
                    <div v-show="selectedCategory == 'general' " class="row px-5 mb-3">
                        <div v-for="question in questions.general" :key="question" class="col-12 ">
                            <h5 class="text-uppercase">{{question.q}}</h5>
                            <p><span v-html="question.a"></span></p>
                        </div>
                    </div>
                    <div v-show="selectedCategory == 'safety' " class="row px-5 mb-3">
                        <div v-for="question in questions.safety" :key="question" class="col-12 ">
                            <h5 class="text-uppercase">{{question.q}}</h5>
                            <p><span v-html="question.a"></span></p>
                        </div>
                    </div>
                    <div v-show="selectedCategory == 'bookings' " class="row px-5 mb-3">
                        <div v-for="question in questions.bookings" :key="question" class="col-12 ">
                            <h5 class="text-uppercase">{{question.q}}</h5>
                            <p><span v-html="question.a"></span></p>
                        </div>
                    </div>
                    <div v-show="selectedCategory == 'tips' " class="row px-5 mb-3">
                        <div v-for="question in questions.tips" :key="question" class="col-12 ">
                            <h5 class="text-uppercase">{{question.q}}</h5>
                            <p><span v-html="question.a"></span></p>
                        </div>
                    </div>
                    <div v-show="selectedCategory == 'corporate' " class="row px-5 mb-3">
                        <!--<div class="row">-->
                            <div class="col-12">
                                <base-alert type="danger">
                                    <span class="alert-inner--icon"><i class="ni ni-notification-70"></i></span>
                                    <span class="alert-inner--text"><strong>Note!</strong></span>
                                    <span class="alert-inner--text"> Our corporate booking policy is affected by the state health and safety regulations.
                                    Please contact us for up to date information on what group sizes we are able to accommodate at this time. </span>
                                </base-alert>

                            </div>
                        <!--</div>-->
                        <div v-for="question in questions.corporate" :key="question" class="col-12 ">
                            <h5 class="text-uppercase">{{question.q}}</h5>
                            <p><span v-html="question.a"></span></p>
                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "FAQ",
        data() {
            return {
                selectedCategory: 'general',
                questions: {
                    general: [
                        {
                            q: "What is an escape room?",
                            a: "<p>An escape room is a live adventure experience where you assemble a team of trusted companions to experience an immersive new world. There you will find hidden clues that will help you solve the various puzzles throughout the environment. These puzzles will take you down the path of solving the game's mysteries and emerging victorious before time runs out!\n</p>"
                        },
                        // {
                        //     q: "Where are you located?",
                        //     a: "<p>Our location is at <strong>1220 Memorex Drive – Suite 300, Santa Clara, CA</strong>. " +
                        //         "You can find more details <a href='/#contact'>here</a>. </p>"
                        // },
                        {
                            q: "What are your open hours?",
                            a: "<p>We are open the following hours:</p>" +
                                "<ul style=\"list-style: none;\">" +
                                "<li><strong>Monday: </strong>12:00 pm - 10:00 pm</li>" +
                                "<li><strong>Tuesday: </strong>12:00 pm - 10:00 pm</li>" +
                                "<li><strong>Wednesday: </strong>12:00 pm - 10:00 pm</li>" +
                                "<li><strong>Thursday: </strong>12:00 pm - 10:00 pm</li>" +
                                "<li><strong>Friday: </strong>12:00 pm - 12:00 am</li>" +
                                "<li><strong>Saturday: </strong>09:30 am - 12:00 am</li>" +
                                "<li><strong>Sunday: </strong>09:30 am - 10:30 pm</li>" +
                                "</ul>" +
                                "<p>If you would like to book outside of these hours, please contact us at " +
                                "<a href='mailto:contact@offthecouchgames.com'>contact@offthecouchgames.com</a></p>"
                        },
                        {
                            q: "Will I be playing with strangers?",
                            a: "Our experiences have, and will always be private. There will be no other people in the experience with you outside of the team you bring."
                        },
                        {
                            q: "What if I want to join another group?",
                            a: "We believe that escape rooms are best experienced with a group of people you know. You cannot book a experience with strangers, but if you would like our help matching you with other enthusiasts, please don't hesitate to reach out to us at " +
                                "<a href='mailto:contact@offthecouchgames.com'>contact@offthecouchgames.com</a>"
                        },
                        {
                            q: "Am I going to be locked in a room?",
                            a: "You are never locked in a room and are free to exit at any time. While we don't recommend breaking out of the immersion of the room, there is no penalty for stepping out.",

                        }, {
                            q: "How long is each experience?",
                            a: "The length of the experience varies. Please check out our experiences " +
                                "<a href='https://www.offthecouchgames.com/#games'>here.</a>"
                        },
                        // {
                        //     q: "When should my group arrive?",
                        //     a: "Please arrive 30 minutes prior to your booking"
                        // },
                        // {
                        //     q: "Why do I need to sign a waiver for each game?",
                        //     a: ""
                        // }, {
                        //     q: "Is there an age limit?",
                        //     a: ""
                        // },{
                        //     q: "Can I bring my child/baby?",
                        //     a: ""
                        // },
                        {
                            q: "Do you offer anything for birthdays, proposals, and other special events?",
                            a: "Absolutely! We're happy to work with you to create a personal and unforgettable experience. Please reach out to us at " +
                                "<a href='mailto:contact@offthecouchgames.com'>contact@offthecouchgames.com</a> "
                        },
                        {
                            q: "Will there be actors in the room with us?",
                            a: "Most of our experiences have light live actor interactions but they will not remain in the room with you for the entirety of the game. If you're not comfortable with actors in the room, please let us know ahead of time and we will adjust the experience for your group to exclude the actor."
                        },
                        // {
                        //     q: "Are you hiring?",
                        //     a: "We are always looking for talented and passionate people to join our team! If you are interested in applying, please email " +
                        //         "<a href='mailto:contact@offthecouchgames.com'>contact@offthecouchgames.com</a>"
                        // },
                        {
                            q: "Can I play by myself?",
                            a: "Escape rooms are best with friends, but if you really want to play solo, we are happy to accommodate you. Please note that different rates may apply. For more information, please contact us at " +
                                "<a href='mailto:contact@offthecouchgames.com'>contact@offthecouchgames.com</a>."
                        },
                    ],
                    safety: [
                        {
                            q: "How are you ensuring the safety of your staff and customers?",
                            a: "Our top priority is to keep both our employees and our customers safe. As part of that, we are strictly adhering to the following safety measures:" +
                                "<ul>" +
                                "<li>All experiences are private. We also capping the number of experiences available to 2 per time window.</li>" +
                                "<li>We provide online waivers that you can fill out on your own device.</li>" +
                                "<li>All players are strongly encouraged to wash their hands before and after each experience.</li>" +
                                "<li>We are allowing for additional 30 minutes between experiences to reset and thoroughly clean all handled items.</li>" +
                                "<li>Employees will be required to wear face masks at all times. </li>" +
                                "<li>Customers will be required to wear face masks when in common areas.</li>" +
                                "</ul>" +
                                "<p>For more information, please check out this " +
                                "<a href='https://www.offthecouchgames.com/otc-reopening'>post.</a></p>"
                        },
                        // {
                        //     q: "How are you ensuring the safety of your staff?",
                        //     a: "test ans"
                        // },
                        // {
                        //     q: "What measures are you taking to prevent the spread of COVID-19?",
                        //     a: "test 3"
                        // },
                        {
                            q: "How often are rooms cleaned?",
                            a: "We clean the rooms between each experience. We are allowing for additional 30 minutes between experiences to reset and thoroughly clean all handled items."
                        },
                        // {
                        //     q: "Do you provide special accommodations to people with disabilities?",
                        //     a: ""
                        // },
                        // {
                        //     q: "Are the rooms scary or dangerous?",
                        //     a: "Some games may be"
                        // },
                        {
                            q: "Member of my group had a bit to drink. Can we still play?",
                            a: "We strictly require that all players are sober throughout the experience for the safety of our customers and our staff. If you need to reschedule, please contact us and soon as possible and we will help!"
                        }
                    ],
                    bookings: [
                        {
                            q: "How do I book an experience?",
                            a: "You can book our experiences " +
                                "<a href='https://offthecouch.io/book/otc'>online</a> " +
                                "or by phone at " +
                                "<a href='tel:408-478-2341'>408-478-2341</a> "
                        },
                        // {
                        //     q: "How much do games cost?",
                        //     a: "test ans"
                        // },
                        {
                            q: "How do I pay?",
                            a: "We accept credit card and cash payments."

                        },
                        {
                            q: "Do you offer gift cards?",
                            a: "Yes! You can purchase a gift voucher " +
                                "<a href='https://offthecouchgamescom.resova.us/gift-voucher'>here.</a> "

                        },
                        {
                            q: "Do you offer discounts?",
                            a: "Please check out our promotions and quests " +
                                "<a href='https://www.offthecouchgames.com/quests'>here.</a> "
                        },
                        {
                            q: "What is your cancellation policy?",
                            a: "We have a strict <strong>NO REFUND</strong> policy. " +
                                "All sales are final and nonrefundable. If you need to reschedule, you must contact us at least 48 hours before your reservation. If you contact us after this period, or if your booking was created within this period, we will do our best to reschedule your booking.  Please note that a rescheduling fee may apply."

                        },
                        {
                            q: "What is your rescheduling policy?",
                            a: "Please note that you can reschedule your experience up to 48 hours before the event. " +
                                "If you need to reschedule within 48 hours of the time of the experience please give us a call at " +
                                "<a href='tel:408-478-2341'>408-478-2341 </a> " +
                                "as soon as you know you can't make the experience.  " +
                                "There may be a rescheduling fee of the minimum booking price of the room (cost for two players) if you do not contact us 48 hours before the game. This fee is taken on a case by case basis so please contact us as soon as you can if you need to reschedule.  "
                        },
                        {
                            q: "I'm not sure how many people will be in my group. Can I add players after I made a reservation?",
                            a: "If you need to add additional players to your experience, you may do so at the time of your booking. "
                        },
                        {
                            q: "My group is larger than your booking limit. How do I add more people?",
                            a: " Since all bookings are private you may add as many as you are comfortable with including. Please note that going above the suggested maximum number of players may result in a \"too many cooks in the kitchen\" experience."
                        }
                    ],
                    tips: [
                        {
                            q: "What is your most beginner-friendly room?",
                            a: "If you are new to escape rooms, we highly recommend " +
                                "<a href='https://www.offthecouchgames.com/inheritance'>Inheritance </a> " +
                                " as a starting point."
                        },{
                            q: "What should I wear?",
                            a: "Please wear comfortable clothing and closed-toed shoes."
                        },
                        {
                            q: "What's the ideal group size?",
                            a: "We recommend 3-6 people for the most optimal experience. However, we'll happily accomodate the group size of your choosing."
                        },
                        // {
                        //     q: "How do I ensure that everyone in my group has fun?",
                        //     a: ""
                        // },{
                        //     q: "What are the strategies to win?",
                        //     a: ""
                        // },
                    ],
                    corporate: [
                        {
                            q: "Do you support corporate events for large parties?",
                            a: "We support corporate team-building events for large teams. " +
                                "For more information, please contact us by email at " +
                                "<a href='mailto:contact@offthecouchgames.com'>contact@offthecouchgames.com</a> " +
                                "or phone at " +
                                "<a href='tel:408-478-2341'>408-478-2341</a> "
                        },{
                            q: "What is the maximum group size you can support?",
                            a: "We can normally accommodate up to 50 people. "
                        },{
                            q: "Can we do catering?",
                            a: "Absolutely. We partner up with local restaurants and would be happy to provide recommendations. " +
                                "Alternatively, we can work with a caterer of your choice."
                        },
                        // {
                        //     q: "Do you offer corporate discounts?",
                        //     a: ""
                        // }
                    ],


                }
            }
        },
        methods: {
            showQuestions(category){
                this.selectedCategory = category
            },
            tracker(category, action, label) {
                this.$ga.event(category, action, label)
            }
        }
    }
</script>

<style scoped>
    .faq-button{
        width: 100%;
    }
    .faq-div {
        margin: 5px;
        padding: 0;
    }

</style>
